import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { formatMoneda, validaMonto, validaSoloNumero } from "../../util/varios";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import CatalogoClassPresupuestaria from "../../catalogos/catalogoClassPresupuestario";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import { Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const ActualizarPresupuesto = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [val, setVal] = useState(0);
  const [val2, setVal2] = useState(0);
  const [idcat, setIdcat] = useState(0);
  const [idpc, setIdpc] = useState(0);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [activo, setActivo] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtIdd = useRef();
  const txtTipoPartidai = useRef();
  const txtTipoPartidag = useRef();
  const txtDescricat = useRef();
  const txtDescriclas = useRef();
  const txtDescriaux = useRef();
  const txtMonto = useRef();
  const txtAuxiliar = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();
  const txt6 = useRef();
  const txt7 = useRef();
  const txt8 = useRef();
  const txt9 = useRef();

  const onChange = (event) => {};

  const onCheck = () => {
    if (txtTipoPartidai.current.checked) {
      setVal(100000000);
      setVal2(399999999);
      setActivo(false);
    } else if (txtTipoPartidag.current.checked) {
      setVal(400000000);
      setVal2(999999999);
      setActivo(false);
    }
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      txtTipoPartidai.current.checked === false &&
      txtTipoPartidag.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo de Partida",
        icono: "informacion",
      });
      sigue = false;
      txtTipoPartidai.current.focus();
    } else if (txt1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Categoria Programatica",
        icono: "informacion",
      });
      sigue = false;
      txt1.current.focus();
    } else if (txt6.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Clasificador Presupuestario",
        icono: "informacion",
      });
      sigue = false;
      txt6.current.focus();
    } else if (txtAuxiliar.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Auxiliar no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtAuxiliar.current.focus();
    } else if (txtMonto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto del Presupuesto",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (txtMonto.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto no puede ser Cero",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar esta Cuenta?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearpresupuesto`;
    let body;
    setActivate(true);

    body = {
      m_cCat: cat.trim(),
      m_cCta: pucc.trim(),
      m_cAux: txtAuxiliar.current.value.trim(),
      m_cDescAux: txtDescriaux.current.value.trim().toUpperCase(),
      m_nMontoInicial: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      m_nEfiscal: idefiscal,
      m_nIdCatPro: parseInt(idcat),
      m_nIdPuc: parseInt(idpc),
      m_cSecgeo: "",
      m_nTippar: 0,
      m_usu: parseInt(idusuario),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Presupuesto Creado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const Reversar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/reversarpresupuesto`;
    let body;
    setActivate(true);

    body = {
      m_cCat: props.presu.categoria.trim(),
      m_cCta: props.presu.puc.trim(),
      m_cAux: txtAuxiliar.current.value.trim(),
      m_cDescAux: txtDescriaux.current.value.trim(),
      m_nEfiscal: idefiscal,
      m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
      m_nIdPuc: parseInt(props.presu.idpuc),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "La Cuenta-" +
                props.presu.idcuenta +
                "-Fue Reversada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setActivate(false);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Reversar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const catalogoClass = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const valueReturn = (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      console.log(event.target.value.length);

      if (event.target.value.length === 1) {
        txtAuxiliar.current.value = "000" + event.target.value;
      } else if (event.target.value.length === 2) {
        txtAuxiliar.current.value = "00" + event.target.value;
      } else if (event.target.value.length === 3) {
        txtAuxiliar.current.value = "0" + event.target.value;
      } else if (event.target.value.length === "") {
        txtAuxiliar.current.value = "0000";
      }
      txtDescriaux.current.focus();
    }
  };
  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    console.log(event.target.name);
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    if (event.which === 13) {
      if (event.target.id === "monto") {
        txtMonto.current.focus();
      }
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);

    txtDescricat.current.value = descripcion.trim();
    txt1.current.value = categoriaprogramatica.substring(0, 2);
    txt2.current.value = categoriaprogramatica.substring(2, 4);
    txt3.current.value = categoriaprogramatica.substring(4, 6);
    txt4.current.value = categoriaprogramatica.substring(6, 8);
    txt5.current.value = categoriaprogramatica.substring(8, 10);
    setCat(categoriaprogramatica);
    setIdcat(idcategoriaprogramatica);
  };

  const handleAceptaClasPresupuestaria = (idpuc, descripcion, puc) => {
    setMostrar3(false);

    txtDescriclas.current.value = descripcion.trim();
    txt6.current.value = puc.substring(0, 3);
    txt7.current.value = puc.substring(3, 5);
    txt8.current.value = puc.substring(5, 7);
    txt9.current.value = puc.substring(7, 9);
    setPucc(puc);
    setIdpc(idpuc);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleCancelaras = () => {
    setMostrar4(false);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.presu);
        } else {
          txtTipoPartidag.current.checked = false;
          txtTipoPartidai.current.checked = false;
          txtDescricat.current.value = "";
          txtDescriclas.current.value = "";
          txtAuxiliar.current.value = "0000";
          txtDescriaux.current.value = "";
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txt6.current.value = "";
          txt7.current.value = "";
          txt8.current.value = "";
          txt9.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Crear Presupuesto."
              : operacion === 2
              ? "Reversar Presupuesto."
              : operacion === 3
              ? "Eliminar Presupuesto."
              : "Consultar Presupuesto."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoCatProgramatica
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatProgramatica={handleAceptaCatProgramatica}
        />
        <CatalogoClassPresupuestaria
          show={mostrar4}
          val={val}
          vals={val2}
          onHideCancelar={handleCancelaras}
          onHideAceptaClasPresupuestaria={handleAceptaClasPresupuestaria}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <fieldset className="row border-azul rounded mx-auto">
            {/*  <legend className="float-none m-0 w-auto ">Datos</legend>
             */}

            {operacion !== 1 ? (
              <div className="input-group input-group-sm col-md-4 my-auto">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Código Cuenta:
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled={true}
                  ref={txtIdd}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  value={values ? values.idcuenta.trim() : ""}
                  id="inputCedula"
                />
              </div>
            ) : (
              ""
            )}

            <fieldset className="row border-azul rounded mx-auto col-md-6">
              <label className="float-none m-0 w-auto my-auto fw-bold mr-4">
                Tipo de Partida
              </label>

              <div className="form-check col">
                <input
                  className="form-check-input my-auto"
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  type="radio"
                  ref={txtTipoPartidai}
                  onChange={onCheck}
                  defaultChecked={
                    props.presu && props.presu.tipopartida === 0 ? true : false
                  }
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="option1"
                />
                <label
                  className="form-check-label my-auto"
                  for="exampleRadios1"
                >
                  Ingresos
                </label>
              </div>
              <div className="form-check col">
                <input
                  className="form-check-input my-auto"
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  type="radio"
                  ref={txtTipoPartidag}
                  onChange={onCheck}
                  defaultChecked={
                    props.presu && props.presu.tipopartida !== 0 ? true : false
                  }
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="option2"
                />
                <label
                  className="form-check-label my-auto"
                  for="exampleRadios2"
                >
                  Gastos
                </label>
              </div>
            </fieldset>
          </fieldset>

          <div className="col-md-12 mx-auto row px-0">

          <fieldset className="row rounded mx-auto border-azul col-md-6 mb-2">
            <legend className="float-none m-0 w-auto">
              Categoria Programatica
            </legend>

            <table class="col-11 mb-1 table table-responsive px-0 border">
              <thead>
                <tr>
                  <th className="text-center" scope="col">
                    Sector
                  </th>
                  <th className="text-center" scope="col">
                    Prog
                  </th>
                  <th className="text-center" scope="col">
                    SubProg
                  </th>
                  <th className="text-center" scope="col">
                    Proy
                  </th>
                  <th className="text-center" scope="col">
                    Act
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="uno"
                      ref={txt1}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              0,
                              2
                            )
                          : ""
                      }
                      className="form-control text-uppercase mr-1 text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="dos"
                      ref={txt2}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              2,
                              4
                            )
                          : ""
                      }
                      className="form-control text-uppercase mr-1 text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="tres"
                      ref={txt3}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              4,
                              6
                            )
                          : ""
                      }
                      className="form-control text-uppercase mr-1 text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cuatro"
                      ref={txt4}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              6,
                              8
                            )
                          : ""
                      }
                      className="form-control text-uppercase mr-1 text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cinco"
                      ref={txt5}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.categoria
                          ? props.categoria.categoriaprogramatica.substring(
                              8,
                              10
                            )
                          : ""
                      }
                      className="form-control text-uppercase text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="col d-flex">
              <button
                disabled={operacion === 4 || operacion === 2 ? true : activo}
                onClick={catalogoCat}
                className="btn btn-sm btn-info my-auto mx-auto rounded-circle"
              >
                <i className="fa fa-search"></i>{" "}
              </button>
            </div>

            <div className="col-12 m-0 mt-1 p-0">
                <Textarea label= 'Descripción'
                    type="textarea"
                    style={{ height: 50 }}
                    disabled={true}
                    defaultValue={
                        props.categoria ? props.categoria.descripcion : ""
                    }
                    placeholder="Descripción de la Categoria Programatica"
                    id="inputDireccion"
                    ref={txtDescricat}
                />
            </div>
          </fieldset>

          <fieldset className="row rounded mx-auto border-azul col-md-6 mb-2">
            <legend className="float-none m-0 w-auto">
              Clasificador Presupuestario
            </legend>

            <table class="col-11 mb-1 table table-responsive px-0 border">
              <thead>
                <tr>
                  <th className="text-center" scope="col">
                    Ramo
                  </th>
                  <th className="text-center" scope="col">
                    Gen
                  </th>
                  <th className="text-center" scope="col">
                    Espec
                  </th>
                  <th className="text-center" scope="col">
                    SubEsp
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="3"
                      name="uno"
                      ref={txt6}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(0, 3) : ""
                      }
                      className="form-control text-uppercase text-center mr-1 "
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="dos"
                      ref={txt7}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(3, 5) : ""
                      }
                      className="form-control text-uppercase text-center mr-1 "
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="tres"
                      ref={txt8}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(5, 7) : ""
                      }
                      className="form-control text-uppercase text-center mr-1 "
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled={true}
                      maxLength="2"
                      name="cuatro"
                      ref={txt9}
                      onChange={onChange}
                      onChangeCapture={handleInputNumChange}
                      defaultValue={
                        props.claspre ? props.claspre.puc.substring(7, 9) : ""
                      }
                      className="form-control text-uppercase text-center "
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="col d-flex">
              <button
                disabled={operacion === 4 || operacion === 2 ? true : activo}
                onClick={catalogoClass}
                className="btn rounded-circle my-auto mx-auto btn-sm  btn-info"
              >
                <i className="fa fa-search"></i>{" "}
              </button>
            </div>

            <div className="col-12 m-0 mt-1 p-0">
                <Textarea label= 'Descripción'
                    type="textarea"
                    style={{ height: 50 }}
                    disabled={true}
                    defaultValue={props.claspre ? props.claspre.descripcion : ""}
                    placeholder="Descripción del Clasificador Presupuestario"
                    id="inputDireccion"
                    ref={txtDescriclas}
                />
            </div>
          </fieldset>
          </div>
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded"> 
            <div className="col-5 m-0 mb-2 p-0">
                <Input label = 'Auxiliar'
                    type="text"
                    autoComplete="off"
                    maxLength="4"
                    disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    ref={txtAuxiliar}
                    defaultValue={
                    props.presu && props.presu.auxiliar !== null
                        ? props.presu.auxiliar
                        : "0000"
                    }
                    placeholder="0000"
                    name="auxiliar"
                    onKeyPress={valueReturn}
                    id="inputDireccion"
                />
            </div>
            <div className="col-7"></div>

            <Textarea label= 'Descripción Auxiliar'
                type="textarea"
                style={{ height: 50 }}
                autoComplete="off"
                disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
                }
                defaultValue={values ? values.descripcionaux.trim() : ""}
                placeholder="Descripción del Auxiliar"
                id="inputDireccion"
                ref={txtDescriaux}
            />
            <div className="col-8"></div>

            <div className="col-md-4 px-0 mt-2">
                <Input label = 'Monto:'
                    type="text"
                    autoComplete="off"
                    disabled={
                      operacion === 4 || operacion === 2 ? true : deshabilitado
                    }
                    defaultValue={
                        values && values.disponibilidad
                        ? formatMoneda(
                            values.disponibilidad
                            .toString()
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2
                        )
                        : ""
                    }
                    onBlur={handleInputMontoChange}
                    onKeyUp={handleInputMontoChange}
                    placeholder="0,00"
                    id="monto"
                    ref={txtMonto}
                />
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton 
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton  onClick={cancelar}>
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
